import { useContext } from "react";

import { userNotificationContext } from "../context/UserNotificationContext";

export const useUserNotificationContext = () => {
  const context = useContext(
    userNotificationContext
  );
  
  if (context === undefined) {
    throw new Error(
      "Hook useUserNotificationContext is used outside of its Provider."
    );
  }

  return context;
};